// Глобальный стор Telegram-аккаунтов traffers: список + агрегаты + WS account:status.
// Бэкенд: GET/POST/DELETE /api/accounts (см. modules/telegram/.../api/server.js).
// account = { id, phone, state, last_used_at, created_at, updated_at, categories[] }.
// state ∈ NEW | WARMUP | READY | FLAGGED | BANNED.
//
// Шаблон — martyrs reactive state + actions. UI-state (фильтры, попапы) — в страницах.

import { reactive } from 'vue';
import { $axios, wsManager } from '@ozdao/martyrs/modules/core/client';
import { storeAuth } from '@ozdao/martyrs/modules/auth/client';

// flaggedCount читает navigation.config.js для бейджа сайдбара «Аккаунты».
const state = reactive({
  accounts: [],
  loading: false,
  loaded: false,
  error: null,
  flaggedCount: 0,
});

let wsInitialized = false;
let wsListenerId = null;

function recomputeFlagged() {
  state.flaggedCount = state.accounts.filter(
    a => a.state === 'FLAGGED' || a.state === 'BANNED'
  ).length;
}

function patchAccount(id, patch) {
  const idx = state.accounts.findIndex(a => a.id === id);
  if (idx >= 0) {
    state.accounts[idx] = { ...state.accounts[idx], ...patch };
    recomputeFlagged();
  }
}

function handleWsMessage(msg) {
  if (!msg || typeof msg !== 'object') return;
  // Воркер/диспетчер шлёт account:status при смене состояния аккаунта
  // (прогрев завершён, флуд-вейт, бан).
  if (msg.type === 'account:status' && msg.data?.accountId) {
    const patch = {};
    if (msg.data.state) patch.state = msg.data.state;
    if (msg.data.lastUsedAt) patch.last_used_at = msg.data.lastUsedAt;
    if (Object.keys(patch).length) patchAccount(msg.data.accountId, patch);
  }
}

const actions = {
  async load(filters = {}) {
    state.loading = true;
    state.error = null;
    try {
      const params = new URLSearchParams();
      if (filters.state) params.set('state', filters.state);
      const qs = params.toString();
      const { data } = await $axios.get(`/api/accounts${qs ? `?${qs}` : ''}`);
      state.accounts = Array.isArray(data) ? data : [];
      state.loaded = true;
      recomputeFlagged();
    } catch (err) {
      if (err?.response?.status !== 401) {
        state.error = err?.response?.data?.error || 'Не удалось загрузить аккаунты';
        console.error('accounts: load failed', err);
      }
    } finally {
      state.loading = false;
    }
  },

  // Добавление аккаунта по session-строке (telethon/gramjs StringSession).
  async add(sessionString) {
    const { data } = await $axios.post('/api/accounts', { sessionString });
    // Оптимистично добавляем в список; бэк вернёт созданную запись.
    if (data && data.id) {
      state.accounts = [data, ...state.accounts];
      recomputeFlagged();
    } else {
      await actions.load();
    }
    return data;
  },

  async remove(id) {
    await $axios.delete(`/api/accounts/${id}`);
    state.accounts = state.accounts.filter(a => a.id !== id);
    recomputeFlagged();
  },

  async init() {
    if (wsInitialized || typeof window === 'undefined') return;
    wsInitialized = true;
    try {
      await wsManager.connect(storeAuth.state.user?._id || null);
      await wsManager.subscribeModule('tasks');
      wsListenerId = wsManager.addEventListener('message', handleWsMessage, { module: 'tasks' });
    } catch (e) {
      wsInitialized = false;
      console.warn('accounts: WS init failed', e);
    }
  },
};

export { state, actions };
